// extracted by mini-css-extract-plugin
export default {"code_snippet":"copy-endpoint_code_snippet__Jl58s"};